// Basic
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
// Store & actions
import useRentalFilesStore from '@/app/store/modules/rentalFiles';
import useRootOrganizationStore from '@/app/store/rootOrganization';
import actionsRentalFiles from '../../api/actionsRentalFiles';
// Components
import DataTable from '../../../../../common-utils/components/renders/dataTable/DataTable';
// Common
import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import mergeQuery from '@/common-utils/components/renders/dataTable/utils/mergeQuery';
import { columnsRentalFiles, columnsRentalFilesId } from './columnDef/columnsRentalFiles';

/**
 * @param root0
 * @param root0.organizationId
 * @param root0.pageActions
 * @param root0.filtersEventName
 * @param root0.urlParams
 * @returns {JSX} RentalFilesTable
 */
function RentalFilesTable({
    pageActions = undefined,
    filtersEventName,
    urlParams = undefined
}) {

    // URL Params
    const { remoteCollectionId } = useParams();

    // Store
    const rootOrganization = useRootOrganizationStore(s => s.rootOrganization);
    const { refetchRentalFiles: refetchFromStore,
        storeRefetchRentalFiles, query: queryStored, storeQuery } = useRentalFilesStore();

    // Constants
    const initialQuery = getInitialQuery();

    // State
    const [query, setQuery] = useState(mergeQuery(initialQuery, queryStored));
    const [launchRefetch, setLaunchRefetch] = useState(true);

    // Api Calls
    const { data, isFetching, error, refetch } = actionsRentalFiles.getRentalFiles(query, false, remoteCollectionId);

    // Hooks
    useEffect(() => {
        if (rootOrganization && (launchRefetch || refetchFromStore)) {
            refetch();
            setLaunchRefetch(false);
            storeRefetchRentalFiles(false);
        }
    }, [query, launchRefetch, refetchFromStore]);

    const allColumns = columnsRentalFiles({
        query,
        setQuery,
        queryStored,
        storeQuery,
        setLaunchRefetch,
        filtersEventName,
        remoteCollectionId,
        urlParams
    });

    // Render
    return (
        <DataTable
            filtersEventName={filtersEventName}
            columns={allColumns}
            data={data}
            dataFetchingIsLoading={isFetching}
            error={error}
            refetch={refetch}
            columnsId={columnsRentalFilesId}
            initialQuery={initialQuery}
            query={query}
            setQuery={setQuery}
            queryStored={queryStored}
            storeQuery={storeQuery}
            setLaunchRefetch={setLaunchRefetch}
            hasPartialResults={true}

            pageActions={pageActions}
        />
    );
}

RentalFilesTable.propTypes = {
    pageActions: PropTypes.node,
    filtersEventName: PropTypes.string,
    urlParams: PropTypes.object
};

export default RentalFilesTable;